<template>
  <div>
    <CRow>
      <CCol col="12" lg="12">
        <CCard>
          <CCardBody>
            <AppForm 
              :key="appFormKey"
              :vo-name="isEdit ? 'PageBuilderGetVo' : 'PageBuilderAddVo'"
              :data="tmpPageBuilder" 
              @changed="onFormChange"
            />
          </CCardBody>
          <CCardFooter>
            <LoadingStateButton
              @click="onAddOrUpdatePageBuilder"
              :text="i18nMessage.Apply"
              color="primary"
              :loading="updatePageBuilderLoading"
            />
            <template v-if="isEdit">
              &nbsp;
              <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
            </template>
            &nbsp;
            <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="showDeleteModal"
        :centered="true"
        color="default"
      >
        {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{pageBuilder.name}}</b>
        <br/><br/>
        <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== pageBuilder.name"
          @click="onDeletePageBuilder"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deletePageBuilderLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID, isEmpty } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'PageBuilder',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpPageBuilder: {},
      updatePageBuilderLoading: false,
      deletePageBuilderLoading: false,
      appFormKey: generateGUID(),
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      pageBuilder: state => state.pageBuilder.pageBuilder,
    }),
  },
  methods: {
    ...mapActions({
      getPageBuilder: 'pageBuilder/getPageBuilder',
      addPageBuilder: 'pageBuilder/addPageBuilder',
      updatePageBuilder: 'pageBuilder/updatePageBuilder',
      deletePageBuilder: 'pageBuilder/deletePageBuilder',
    }),
    ...mapMutations({
      setPageBuilder: 'pageBuilder/setPageBuilder',
    }),
    goBack() {
      this.$router.push({path: '/page-builder'})
    },
    onEditorContentChange (template, style) {
      this.tmpPageBuilder = {
        ...this.tmpPageBuilder,
        template,
        style,
      }
    },
    onFormChange (data) {
      this.tmpPageBuilder = {...data}
    },
    onDeletePageBuilder () {
      this.deletePageBuilderLoading = true
      this.deletePageBuilder(this.pageBuilder.id)
          .then(() => {
            this.deletePageBuilderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deletePageBuilderLoading = false
            this.showDeleteModal = false
          })
    },
    onAddOrUpdatePageBuilder () {
      if (isEmpty(this.tmpPageBuilder)) {
        return
      }
      if (this.tmpPageBuilder.id) {
        this.updatePageBuilderLoading = true
        this.updatePageBuilder(this.tmpPageBuilder)
          .then(() => {
            this.updatePageBuilderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updatePageBuilderLoading = false
          })
      } else {
        this.updatePageBuilderLoading = true
        this.addPageBuilder(this.tmpPageBuilder)
          .then(() => {
            this.updatePageBuilderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updatePageBuilderLoading = false
          })
      }
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getPageBuilder(this.$route.params.id).then(() => {
        this.tmpPageBuilder = this.pageBuilder
      })
    }
  },
  destroyed() {
    this.setPageBuilder({})
  }
}
</script>
